module.exports = __webpack_public_path__ + "img/colc-img.42a83593.jpg";